import { Model } from './model';
import { Fabbricato } from './fabbricato';

export class ClasseFabbricato extends Model {
  static apiUrl: string = "classi_fabbricato";

  nome: string;
  fabbricati: Fabbricato[];

  deserialize(input: any): ClasseFabbricato {
    let retV: ClasseFabbricato = new ClasseFabbricato();

    retV = super.deserialize(input) as ClasseFabbricato;

    if (input?.fabbricati) {
      retV.fabbricati = input.fabbricati.map(m => new Fabbricato().deserialize(m));
    }

    return retV;
  }

}
